import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';

// Components
import { Stepper } from "./components/Stepper";

// Target
const target = document.getElementById("__backpress_finder__");

const App = ( { layout, base_url } ) => {
    return (
        <div className={`finder-wrapper layout-${layout}`}>
            <Stepper base_url={ base_url } />
        </div>
    )
}

ReactDOM.render(
    <React.StrictMode>
        <App layout={target.dataset.layout} base_url={target.dataset.url} />
    </React.StrictMode>,
    target
);
